import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import { Button, ConfirmationModal, FormUI } from "@parkschannel/ui";
import { useTripPlanerContext } from "../TripPlannerContext";
import { PlannerNameForm } from "../PlannerNameForm";
import { useRouter } from "next/router";
import { successToast } from "../../../Toast";
import { useAnalytics } from "../../../../utils";
export const SaveButton = ()=>{
    const { onCreatePlanner  } = useAnalytics();
    const router = useRouter();
    const [isOpen, setIsOpen] = useState(false);
    const { onSavePlanner , onNameChange , planner  } = useTripPlanerContext();
    const handleSavePlan = async (submitData)=>{
        await onSavePlanner({
            ...planner,
            name: submitData.name
        }, async ()=>{
            onCreatePlanner();
            successToast({
                description: "You are ready to go! The checklist is saved on your profile"
            });
            onNameChange(submitData.name);
            await router.push("/users/me/checklists/");
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Button, {
                variant: "outline",
                onClick: ()=>setIsOpen(true),
                children: "Save"
            }),
            /*#__PURE__*/ _jsx(ConfirmationModal, {
                contentClassName: "!max-w-[600px]",
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                onConfirm: onSavePlanner,
                actionButtons: ()=>null,
                children: /*#__PURE__*/ _jsx(PlannerNameForm, {
                    onCancel: ()=>setIsOpen(false),
                    renderButtons: (submit)=>/*#__PURE__*/ _jsxs("div", {
                            className: "flex gap-2",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    size: "sm",
                                    variant: "outline",
                                    onClick: ()=>setIsOpen(false),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ _jsx(FormUI.SubmitButton, {
                                    size: "sm",
                                    onClick: (e)=>submit(handleSavePlan)(e),
                                    children: "Save"
                                })
                            ]
                        })
                })
            })
        ]
    });
};
